(function() {
  /**
   * Watches for the A/B test class on the body and triggers a resize 
   * to ensure hidden sliders initialize correctly when revealed.
   */
  function handleTestClassChange() {
    if (document.body.classList.contains('home_001-Hero-Section-Redesign')) {
      
      // 1. Trigger a global window resize (fix for most responsive elements)
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 50);

      // 2. Specifically target Flickity instances in the migrated slideshow
      setTimeout(() => {
        const slideshows = document.querySelectorAll('.et-migrated-slideshow slide-show');
        slideshows.forEach(el => {
          if (typeof Flickity !== 'undefined' && Flickity.data(el)) {
            Flickity.data(el).resize();
            Flickity.data(el).reposition();
          }
        });
      }, 100);
    }
  }

  // Observe body for class changes (e.g. from A/B test tools or devtools)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'class') {
        handleTestClassChange();
      }
    });
  });

  observer.observe(document.body, { attributes: true });

  // Initial check
  if (document.readyState !== 'loading') {
    handleTestClassChange();
  } else {
    document.addEventListener('DOMContentLoaded', handleTestClassChange);
  }
})();
